import React from "react";
import { ReadStatusChip } from "styles/components/deviceAlarms.styles";

interface AlarmReadStatusChipProps {
  isRead: boolean;
}

const AlarmReadStatusChip: React.FC<AlarmReadStatusChipProps> = ({
  isRead,
}) => {
  return (
    <ReadStatusChip isRead={isRead}>
      {isRead ? "Read" : "Unread"}
    </ReadStatusChip>
  );
};

export default AlarmReadStatusChip;
